// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'

const CopyFail = ({ modalHeading, modalMessage }) => (
  <div className={'path-details-footer-modal'}>
    <h3 className={'center-text uppercase padding-half'}>
      <span className={'text-blue-dark'}>{modalHeading}</span>
      <span className={'alert-decoration'} />
    </h3>
    <p className={'padding-half center-text'}>
      <strong>{modalMessage}</strong>
    </p>
  </div>
)

CopyFail.propTypes = {
  modalHeading: string.isRequired,
  modalMessage: string.isRequired,
}

export default CopyFail
